import { rollLaunch, rollLeave } from '@/api/game'
import { showNotice } from '@/utils/tool'
import store from 'vuex-store/index'
import router from '@/router'
import i18n from '@/i18n'

// type = game or provider
export function rollStart(type, gameOrProvider) {
  if (!store.getters.token) {
    // 未登入
    showNotice(i18n.t('Bao.please_login_for_function'))
    router.replace({ path: '/user/login' })
  }
  if (store.getters.permissionInfo.enable_roll === 0) {
    // 遊戲維護中
    showNotice(i18n.t('Bao.game_maintenance'))
  }

  // loading開始
  store.commit('SET_LOADING', true)

  var newWindow = window.open('/loading_game.html', '_blank')

  rollLaunch().then(response => {
    const result = response.data.data
    const url = result.url

    // loading結束
    store.commit('SET_LOADING', false)

    if (newWindow !== null) {
      // 母視窗提醒
      // showNotice(i18n.t('Bao.in_game_notice'), function() {
      //   newWindow.close()
      // })

      // 開新視窗
      newWindow.location = url

      var startCheck = false

      // 偵測新視窗是否關閉
      var y = window.setInterval(function() {
        try {
          var newHost = newWindow.location.host
        } catch (e) {
          newHost = 'cross domain'
        }

        console.log('detect..', newHost, startCheck)
        if (newHost !== window.location.host) {
          startCheck = true
        }

        if (newHost === window.location.host && startCheck) {
          // 新視窗回到包網
          newWindow.close()
          window.clearInterval(y)
          gameEnd()
        } else if (newWindow.closed) {
          // 新視窗已經關閉
          window.clearInterval(y)
          gameEnd()
        }
      }, 1000)
    } else {
      // 原本視窗整頁轉向
      window.location.href = url
    }
  }).catch((error) => {
    console.log(error)

    if (newWindow !== null) {
      newWindow.close()
    }
  })
}

export function gameEnd() {
  if (!store.getters.token) {
    return
  }
  // loading開始
  store.commit('SET_LOADING', true)

  showNotice('closeModal')

  rollLeave().then(response => {
    // loading結束
    store.commit('SET_LOADING', false)
  })
}
